import { Injectable } from '@angular/core';

export interface StorageItem {
  value: any;
  expiry: number;
}

@Injectable({
  providedIn: 'root'
})
export class AuthStorageService {
  private readonly EXPIRY_DAYS = 30;

  constructor() {}

 
  setItem(key: string, value: any): void {
    const now = new Date();
    const expiry = now.getTime() + (this.EXPIRY_DAYS * 24 * 60 * 60 * 1000); // 30 days in milliseconds
    
    const item: StorageItem = {
      value: value,
      expiry: expiry
    };
    
    localStorage.setItem(key, JSON.stringify(item));
  }

 
  getItem(key: string): any {
    const itemStr = localStorage.getItem(key);
    
    if (!itemStr) {
      return null;
    }

    try {
      const item: StorageItem = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    } catch (error) {
      localStorage.removeItem(key);
      return null;
    }
  }

 
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clearAuthData(): void {
    this.removeItem('user');
    this.removeItem('accessToken');
  }

  isAuthenticated(): boolean {
    const user = this.getItem('user');
    return user !== null;
  }


}
